import { render, staticRenderFns } from "./LifeskillBraindatesItem.vue?vue&type=template&id=7ba28b3d&scoped=true&"
import script from "./LifeskillBraindatesItem.vue?vue&type=script&lang=js&"
export * from "./LifeskillBraindatesItem.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillBraindatesItem.vue?vue&type=style&index=0&id=7ba28b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba28b3d",
  null
  
)

/* custom blocks */
import block0 from "./LifeskillBraindatesItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports